import { useAuth0 } from '@auth0/auth0-react';

export function ProtectedRoute({ children }) {
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center border-2 border-ink shadow-brutal rounded-xl bg-surface p-10">
          <img src="/favicon.png" alt="Mercury" className="h-12 w-12 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-text-primary mb-2 font-grotesk">Mercury</h1>
          <p className="text-text-secondary mb-6">VTTD Email Orchestration</p>
          <button
            onClick={() => loginWithRedirect()}
            className="px-8 py-2.5 bg-primary text-white rounded-xl font-semibold btn-brutal hover:-translate-y-0.5 hover:shadow-brutal-lg active:translate-y-0.5 active:shadow-brutal-sm transition-all duration-200"
          >
            Sign In
          </button>
        </div>
      </div>
    );
  }

  return children;
}
